
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { DeviceType, AppModule } from '@/store/modules/app'
import { SettingsModule } from '@/store/modules/settings'
import { PermissionModule } from '@/store/modules/permission'
import { UserModule } from '@/store/modules/user'
import { RightModule } from '@/store/modules/right'
import { MenuModule } from '@/store/modules/menu'
import variables from '@/styles/_variables.scss'
import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components'
import RightPanel from '@/components/RightPanel/index.vue'
import ResizeMixin from './mixin/resize'
import { loginOut } from '@/api/users'

@Component({
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    RightPanel,
    Settings,
    Sidebar,
    TagsView
  }
})
export default class extends mixins(ResizeMixin) {
  private logo = require('../assets/statics/pics/logo.png')
  private reloadPage () {
    (this.$refs.appMain as any).reload()
  }

  private routes: any = PermissionModule.routes.filter(v => !v.meta.hidden)

  get curMenu () {
    return MenuModule.name
  }

  get classObj () {
    return {
      hideSidebar: !this.sidebar.opened,
      openSidebar: this.sidebar.opened,
      withoutAnimation: this.sidebar.withoutAnimation,
      // 为了使侧边栏菜单不会消失，故如下变更为mobile:false
      // 如何判断设备类型，请参照resize.ts中的isMobile()方法
      // mobile: this.device === DeviceType.Mobile
      mobile: false
    }
  }

  get menuBg () {
    if (SettingsModule.menuTheme) {
      return SettingsModule.menuTheme
    } else {
      return variables.menuBg
    }
  }

  get showSettings () {
    return SettingsModule.showSettings
  }

  get showTagsView () {
    return SettingsModule.showTagsView
  }

  get showSubNav () {
    return SettingsModule.showSubNav
  }

  get fixedHeader () {
    return SettingsModule.fixedHeader
  }

  private handleClickOutside () {
    AppModule.CloseSideBar(false)
  }

  get sidebar () {
    return AppModule.sidebar
  }

  get devicetype () {
    return AppModule.device.toString()
  }

  get avatar () {
    return RightModule.userInfo.avatar
  }

  get userinfo () {
    return { userName: RightModule.userinfo.userName || UserModule.userName }
  }

  private async logout () {
    // this.curMenu = ''
    await loginOut().then(async () => {
      MenuModule.updateMenuName(this.curMenu)
      await UserModule.LogOut()
      this.$router
        .push(`/login?redirect=${this.$route.fullPath}`)
        .catch((err) => {
          console.warn(err)
        })
    })
  }

  private menuClick (name: any) {
    // this.curMenu = name
    MenuModule.updateMenuName(name)
    this.$router.push(MenuModule.subMenu[0].path)
  }

  private updateMenuName () {
    MenuModule.updateMenuName(this.curMenu)
  }
}
